import { useEffect } from 'react';
import { Analytics } from 'aws-amplify';

interface UseAnalyticsOptions {
  sessionTracking?: boolean;
  pageTracking?: boolean;
  pageEventName?: string;
}

export const useAnalytics = ({
  sessionTracking = true,
  pageTracking = true,
  pageEventName = 'PageView'
}: UseAnalyticsOptions = {}) => {
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        if (sessionTracking) {
          await Analytics.autoTrack('session', {
            enable: true
          });
        }

        if (pageTracking) {
          await Analytics.autoTrack('pageView', {
            enable: true,
            eventName: pageEventName,
            type: 'SPA',
            getUrl: () => window.location.origin + window.location.pathname
          });
        }
      } catch (error) {
        console.warn('Analytics configuration failed, continuing without analytics:', error);
      }
    };

    initializeAnalytics();
  }, [sessionTracking, pageTracking, pageEventName]);

  const trackEvent = async (name: string, attributes?: Record<string, any>) => {
    try {
      await Analytics.record({
        name,
        attributes
      });
    } catch (error) {
      console.error('Failed to track event:', error);
    }
  };

  return { trackEvent };
};